import React from "react";

function SuccessPage() {
    return (
        <div className="flex flex-col h-screen flex justify-center items-center">
            <h3 className="font-bold" style={{color: 'green', padding: '10px'}}>SUCCESS :)</h3>
            <div style={{
                color: 'green',
                border: '1px solid green',
                padding: '10px',
                paddingLeft: '40px',
                paddingRight: '40px',
                borderRadius: '5px'
            }}> Your transaction is successful
            </div>
        </div>
    );
}

export default SuccessPage;